import React, { useRef, useState, useEffect } from 'react';

const PathRecorderPage = () => {
    const canvasRef = useRef(null);
    const [isRecording, setIsRecording] = useState(false);
    const [points, setPoints] = useState([]);
    const [textToRecord, setTextToRecord] = useState("จ่อมเจาะเดาะด้อย");
    const [exportedData, setExportedData] = useState("");

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;

        const w = canvas.width;
        const h = canvas.height;

        ctx.clearRect(0, 0, w, h);

        ctx.beginPath();
        ctx.strokeStyle = '#cbd5e1';
        ctx.lineWidth = 2;
        ctx.moveTo(w * 0.05, h * 0.5);
        ctx.lineTo(w * 0.95, h * 0.5);
        ctx.stroke();

        ctx.font = "bold 60px 'LNTilok', sans-serif";
        ctx.fillStyle = 'rgba(0, 0, 0, 0.2)';
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(textToRecord, w / 2, h / 2);

        // วาดเส้นที่บันทึกแล้ว โดยเช็คการยกปากกา (newStroke)
        if (points.length > 0) {
            ctx.beginPath();
            ctx.strokeStyle = '#ef4444';
            ctx.lineWidth = 4;
            ctx.lineCap = 'round';
            ctx.lineJoin = 'round';
            
            for (let i = 0; i < points.length; i++) {
                // ถ้าเป็นจุดแรก หรือมีการระบุว่าเริ่มเส้นใหม่ ให้ทำการ "ยกมาวาง (moveTo)"
                if (i === 0 || points[i].newStroke) {
                    ctx.moveTo(points[i].x, points[i].y);
                } else {
                    // ถ้าเป็นเส้นต่อเนื่อง ให้ "ลากเส้น (lineTo)"
                    ctx.lineTo(points[i].x, points[i].y);
                }
            }
            ctx.stroke();
        }
    }, [textToRecord, points]);

    // ตอนกดเมาส์/แตะจอครั้งแรก ให้บันทึกว่าเป็นเส้นใหม่ (newStroke: true)
    const startRecording = (clientX, clientY) => {
        setIsRecording(true);
        const rect = canvasRef.current.getBoundingClientRect();
        const x = Math.round(clientX - rect.left);
        const y = Math.round(clientY - rect.top);
        setPoints(prev => [...prev, { x, y, newStroke: true }]);
    };

    const stopRecording = () => {
        setIsRecording(false);
    };

    // ตอนลากเมาส์ ไม่ต้องใส่ newStroke
    const recordPoint = (clientX, clientY) => {
        if (!isRecording) return;
        const rect = canvasRef.current.getBoundingClientRect();
        const x = Math.round(clientX - rect.left);
        const y = Math.round(clientY - rect.top);

        const lastPoint = points[points.length - 1];
        if (lastPoint) {
            const dx = x - lastPoint.x;
            const dy = y - lastPoint.y;
            if (Math.sqrt(dx * dx + dy * dy) > 5) {
                setPoints(prev => [...prev, { x, y }]);
            }
        }
    };

    const clearPoints = () => {
        setPoints([]);
        setExportedData("");
    };

    const exportToJson = () => {
        const json = JSON.stringify(points);
        setExportedData(json);
    };

    return (
        <div className="min-h-screen bg-gray-100 p-8 flex flex-col items-center font-sans">
            <h1 className="text-2xl font-bold mb-4">เครื่องมือสร้างพิกัด (Path Recorder)</h1>
            <div className="mb-4 flex gap-4 w-full max-w-lg">
                <input 
                    type="text" value={textToRecord}
                    onChange={(e) => { setTextToRecord(e.target.value); clearPoints(); }}
                    className="flex-1 p-2 border rounded" placeholder="พิมพ์สำนวนที่ต้องการสร้างพิกัด"
                />
            </div>
            <p className="mb-2 text-sm text-gray-600">กดลากเส้นแล้วยกเมาส์ไปเริ่มตัวใหม่ได้เลย ระบบจะจำการยกปากกาให้แล้ว</p>
            <div className="relative bg-white shadow-lg border w-full max-w-2xl aspect-[2/1] mb-4">
                <canvas
                    ref={canvasRef}
                    className="w-full h-full cursor-crosshair touch-none"
                    onMouseDown={(e) => startRecording(e.clientX, e.clientY)}
                    onMouseUp={stopRecording}
                    onMouseLeave={stopRecording}
                    onMouseMove={(e) => recordPoint(e.clientX, e.clientY)}
                    onTouchStart={(e) => startRecording(e.touches[0].clientX, e.touches[0].clientY)}
                    onTouchEnd={stopRecording}
                    onTouchMove={(e) => recordPoint(e.touches[0].clientX, e.touches[0].clientY)}
                />
            </div>
            <div className="flex gap-4 mb-4">
                <button onClick={clearPoints} className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600">เคลียร์เส้นทิ้ง</button>
                <button onClick={exportToJson} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">ส่งออกข้อมูล</button>
            </div>
            {exportedData && (
                <div className="w-full max-w-2xl">
                    <textarea readOnly value={exportedData} className="w-full h-40 p-2 text-xs font-mono border rounded bg-gray-50"/>
                </div>
            )}
        </div>
    );
};

export default PathRecorderPage;